<template>
  <div class="lh-15 c-333">
    <ProductBanner
      :banner-img="bannerImg"
      :product-name="$t('common.productName.vidar')"
      :custom-style="{ bottom: '2.44rem', left: '2rem' }"
      :main-title="$t('products.vidar.bannerTitle')"
      :sub-title="$t('products.vidar.bannerSubTitle')"
    />
    <div class="content p-r z-3 bgc-fff">
      <NavAnchor :product-name="$t('common.productName.vidar')" :spec-url="'/product/lawnmowerspec'" />
      <IconWrap :icon-wrap-data="iconWrapData" />
      <videoWrap class="area-2" :video-info="videoInfo" />
      <!-- area3 -->
      <section class="area-3">
        <div class="w-12r m-a">
          <h2 class="ta-c">Key Benefits</h2>
          <div class="desc ta-c c-666">Under the condition of mowing 20 acres with 2 electric mowers.</div>
          <div class="d-f jc-sb ai-c">
            <div class="img-box">
              <img class="lazy-image" v-lazy="area3Img" width="100%" height="100%" alt="Key Benefits" />
            </div>
            <div class="text d-f fd-c ov-h">
              <div class="reveal">
                <strong class="d-b ta-c lh-1 c-333">50%</strong>
                <hr class="line" />
                <span class="d-b ta-c fw-500">Labor Cost</span>
              </div>
              <div class="reveal">
                <strong class="d-b ta-c lh-1 c-333">100%</strong>
                <hr class="line" />
                <span class="d-b ta-c fw-500">Efficiency</span>
              </div>
            </div>
          </div>
        </div>
      </section>
      <!-- 轮播 -->
      <Carousel
        :carousel-wrap="{ padding: '0 3.6rem' }"
        :wrapper-class="'pl-360 pr-360'"
        ref="carousel"
        :title="carouselTitle"
        :swiper-option="swiperOption"
        :swiper-data="swiperData"
      />
      <!-- 左右横向滚动 -->
      <div class="area-5">
        <div class="area-5-content d-f ov-h">
          <section class="panner-1 p-r">
            <div class="w-12r">
              <h2 class="c-fff ta-c">Autonomous Mowing <br class="in-h5" />Experience</h2>
              <div class="desc">
                Thanks to the FJD RTK positioning system, Vidar sets up a virtual boundary and creates a map with
                centimeter-level accuracy. It provides selective paths to avoid overlaps and minimize skips, which
                significantly improves cutting efficiency.
              </div>
            </div>
          </section>
          <section class="panner-2 p-r d-f ai-c">
            <div class="d-f jc-sb">
              <div class="mod-1">
                <div class="text">
                  <h2 class="c-fff">RTK Path Planning</h2>
                  <div class="c-fff">Generates a zigzag or spiral path with centimeter-level precision.</div>
                </div>
                <div class="img-box">
                  <video
                    class=""
                    width="100%"
                    height="100%"
                    x5-playsinline
                    x5-video-player-type="h5"
                    x-webkit-airplay="allow"
                    playsinline
                    webkit-playsinline
                    muted
                    loop
                    autoplay
                    preload="none"
                    :poster="require('@/assets/images/fjd-vidar/area-5-video1-cover.jpg')"
                    src="//1500006283.vod2.myqcloud.com/6c9ac49bvodcq1500006283/e15ac246387702305404044275/6dv0IbgAMOsA.mp4"
                  ></video>
                </div>
              </div>
              <div class="mod-2">
                <div class="text">
                  <h2 class="c-fff">Real-Time Obstacle Detection</h2>
                  <div class="c-fff">
                    The vision-based sensor detects obstructions over 1-meter in height within a 3.5-meter distance.
                  </div>
                </div>
                <div class="img-box">
                  <video
                    class=""
                    width="100%"
                    height="100%"
                    x5-playsinline
                    x5-video-player-type="h5"
                    x-webkit-airplay="allow"
                    playsinline
                    webkit-playsinline
                    muted
                    loop
                    autoplay
                    preload="none"
                    :poster="require('@/assets/images/fjd-vidar/area-5-video2-cover.jpg')"
                    src="//1500006283.vod2.myqcloud.com/6c9ac49bvodcq1500006283/e5e28789387702305404227266/px1Afbn7pjwA.mp4"
                  ></video>
                </div>
              </div>
            </div>
          </section>
        </div>
      </div>
      <!-- 图文 -->
      <ImgDesc id="features" :is-reverse="1" :img-desc-data="imgDescData" :main-title="mainTitle" />
      <!-- 序列帧动画 -->
      <section class="area-7">
        <div class="area-7-content d-f ai-c jc-c in-pc">
          <div class="img-box">
            <img id="area-7-img" src="@/assets/images/fjd-vidar/framesequence/CG1_00.png" width="100%" height="100%" />
          </div>
          <div class="desc-wrap p-r">
            <h2 id="safety-title">All For Safety</h2>
            <div class="desc-text" id="indicator-light">
              <h3>Indicator light</h3>
              <div>Lights up as a reminder at work.</div>
              <h3>Gravity sensing seat</h3>
              <div>Triggers the brake within 2 seconds when the operator leaves the seat.</div>
            </div>
            <!-- <div class="desc-text" id="seat">
              <h3>Gravity sensing seat</h3>
              <div>Triggers the brake within 2 seconds when the operator leaves the seat.</div>
            </div> -->
            <div class="desc-text" id="hand-brake">
              <h3>Hand brake</h3>
              <div>Pushes the levers to the sides to stop the mower.</div>
              <h3>Foot brake</h3>
              <div>Stops the mower immediately in emergencies.</div>
            </div>
            <!-- <div class="desc-text" id="foot-brake">
              <h3>Foot brake</h3>
              <div>Stops the mower immediately in emergencies. </div>
            </div> -->
            <div class="desc-text" id="stop-button">
              <h3>Emergency stop button</h3>
              <div>Stops the mower immediately with one push.</div>
            </div>
          </div>
        </div>
        <div class="area-7-content in-h5">
          <h2>All For Safety</h2>
          <!-- 轮播效果样式2:start -->
          <div class="swiper-style2">
            <div class="swiper-wrapper">
              <div class="swiper-slide">
                <div class="img-wrapper">
                  <img src="@/assets/images/fjd-vidar/01.png" width="100%" height="100%" alt="Indicator light" />
                </div>
              </div>
              <div class="swiper-slide">
                <div class="img-wrapper">
                  <img src="@/assets/images/fjd-vidar/02.png" width="100%" height="100%" alt="Gravity sensing seat" />
                </div>
              </div>
              <div class="swiper-slide">
                <div class="img-wrapper">
                  <img src="@/assets/images/fjd-vidar/03.png" width="100%" height="100%" alt="Hand brake" />
                </div>
              </div>
              <div class="swiper-slide">
                <div class="img-wrapper">
                  <img src="@/assets/images/fjd-vidar/04.png" width="100%" height="100%" alt="foot brake" />
                </div>
              </div>
              <div class="swiper-slide">
                <div class="img-wrapper">
                  <img src="@/assets/images/fjd-vidar/05.png" width="100%" height="100%" alt="Emergency stop button" />
                </div>
              </div>
            </div>
            <div class="swiper-pagination-wrapper"></div>
            <div class="swiper-text-wrapper">
              <div>
                <h3 class="c-333 fw-500">Indicator light</h3>
                <div>Lights up as a reminder at work.</div>
              </div>
              <div>
                <h3 class="c-333 fw-500">Gravity sensing seat</h3>
                <div>Triggers the brake within 2 seconds when the operator leaves the seat.</div>
              </div>
              <div>
                <h3 class="c-333 fw-500">Hand brake</h3>
                <div>Pushes the levers to the sides to stop the mower.</div>
              </div>
              <div>
                <h3 class="c-333 fw-500">Foot brake</h3>
                <div>Stops the mower immediately in emergencies.</div>
              </div>
              <div>
                <h3 class="c-333 fw-500">Emergency stop button</h3>
                <div>Stops the mower immediately with one push.</div>
              </div>
            </div>
            <div class="swiper-button-wrapper in-pc">
              <div class="swiper-button-prev"></div>
              <div class="swiper-button-next"></div>
            </div>
          </div>
          <!-- 轮播效果样式2:end -->
        </div>
      </section>
      <!-- 左右切换轮播图 -->
      <leftRightCarousel
        :swiper-option="leftRightswiperOption"
        :active-index="activeIndex"
        :swiper-data="leftRightswiperData"
        :title="leftRightSwiperTitle"
      />
      <!-- 最后一屏 -->
      <section class="area-9">
        <div class="area-9-in">
          <h2 class="ta-c">Accessories</h2>
          <div class="img-box from-bottom">
            <img
              class="lazy-image"
              v-lazy="area9Img"
              data-original="../images/fjd-vidar/area-9-1.png"
              width="100%"
              height="100%"
              alt="Mulching kits"
            />
          </div>
          <h3 class="d-b ta-c c-333">Mulching kit</h3>
          <div class="c-666">
            Vidar Mulch kit seals the discharge opening to recycle the lawn clippings into the 42” blade area for a
            clean cut to manicure your lawn with fine mulch clippings.
          </div>
        </div>
      </section>
    </div>
  </div>
</template>

<script>
  import { gsap } from 'gsap'
  import { ScrollTrigger } from 'gsap/dist/ScrollTrigger.js'
  import bannerImg from '@/assets/images/fjd-vidar/banner.jpg'
  import area2Img from '@/assets/images/fjd-vidar/mian-video-cover.jpg'
  import area3Img from '@/assets/images/fjd-vidar/area-3.jpg'

  import swiper1img from '@/assets/images/fjd-vidar/area-4-video1-cover.jpg'
  import swiper2img from '@/assets/images/fjd-vidar/area-4-video2-cover.jpg'
  import swiper3img from '@/assets/images/fjd-vidar/area-4-video3-cover.jpg'
  // import a from '../../../assets/images/fjd-vidar/framesequence/CG1_00.png'

  import area6Video1img from '@/assets/images/fjd-vidar/area-6-video1-cover.jpg'
  import area6Video2img from '@/assets/images/fjd-vidar/area-6-video2-cover.jpg'
  import area6Video3img from '@/assets/images/fjd-vidar/area-6-video3-cover.jpg'

  import leftRightSwiper1img from '@/assets/images/fjd-vidar/area-8-1.jpg'
  import leftRightSwiper2img from '@/assets/images/fjd-vidar/area-8-2.jpg'
  import leftRightSwiper3img from '@/assets/images/fjd-vidar/area-8-3.jpg'
  import leftRightSwiper4img from '@/assets/images/fjd-vidar/area-8-4.jpg'

  import area9Img from '@/assets/images/fjd-vidar/area-9-1.png'

  import ProductBanner from '@/components/ProductBanner'
  import NavAnchor from '@/components/NavAnchor'
  import IconWrap from '@/components/IconWrap'
  import videoWrap from '@/components/videoWrap'
  import Carousel from '@/components/Carousel/Carousel'
  import leftRightCarousel from '@/components/Carousel/leftRightCarousel'

  import ImgDesc from '@/components/ImgDesc'

  // import Application from '@/components/Application'
  // import CustomerCard from '@/components/CustomerCard'
  // import BlogCard from '@/components/BlogCard'
  import bannerScroll from '@/mixins/bannerScroll.js'
  const area8TabItem = [
    'products.vidar.area4Tab1Title',
    'products.vidar.area4Tab2Title',
    'products.vidar.area4Tab3Title'
  ]
  export default {
    components: {
      ProductBanner,
      NavAnchor,
      IconWrap,
      videoWrap,
      Carousel,
      ImgDesc,
      leftRightCarousel
      // Application,
      // CustomerCard,
      // BlogCard
    },
    mixins: [bannerScroll],
    data() {
      const vm = this
      return {
        bannerImg,
        area3Img,
        area9Img,
        iconWrapData: [
          {
            icon: 'rtk-path-planning',
            vHtml: 'products.vidar.icon1'
          },
          {
            icon: 'real-time-obstacle',
            vHtml: 'products.vidar.icon2'
          },
          {
            icon: 'breakpoint-resumptio',
            vHtml: 'products.vidar.icon3'
          },
          {
            icon: 'up-6-acres',
            vHtml: 'products.vidar.icon4'
          },
          {
            icon: 'electric-control',
            vHtml: 'products.vidar.icon5'
          },
          {
            icon: 'auto-mode',
            vHtml: 'products.vidar.icon6'
          }
        ],
        videoInfo: {
          h2: 'products.vidar.area2H2',
          desc: 'products.vidar.area2Desc',
          poster: area2Img,
          src: 'https://1500006283.vod2.myqcloud.com/6c9ac49bvodcq1500006283/23aa00fe387702305646696485/wU9g159Tym8A.mp4'
        },
        carouselTitle: 'products.vidar.area4H2',
        swiperOption: {
          // loop: true,
          slidesPerView: 1,
          spaceBetween: 0,
          effect: 'slide',
          pagination: {
            el: '.area-8-swiper-tab',
            clickable: true,
            renderBullet(index, className) {
              return '<span class="' + className + '">' + vm.$t(area8TabItem[index]) + '</span>'
            }
          },
          on: {
            init() {
              vm.videos = document.querySelectorAll('.area-8-swiper video')
              const playPromise = vm.videos[0].play()
              if (playPromise !== undefined) {
                playPromise
                  .then(() => {
                    vm.videos[0].play()
                  })
                  .catch((e) => {
                    console.log('[ e ] >', e)
                  })
              }
            },
            slideChange() {
              const index = this.realIndex
              // console.log('[ vm.$refs ] >', vm.$refs)
              vm.$refs.carousel.$refs.swiperLine.style.transform = `translateX(${index * 100}%)`
              const curPlayVideo = vm.videos[index]
              curPlayVideo.play()
            }
          }
        },

        swiperData: [
          {
            videoSrc:
              '//1500006283.vod2.myqcloud.com/6c9ac49bvodcq1500006283/e62aed44387702305404267320/H1aPfZJaKYcA.mp4',
            // src: '//1500006283.vod2.myqcloud.com/6c9ac49bvodcq1500006283/e62aed44387702305404267320/H1aPfZJaKYcA.mp4',
            img: swiper1img,
            desc: 'products.vidar.area4Tab1Desc'
          },
          {
            videoSrc:
              '//1500006283.vod2.myqcloud.com/6c9ac49bvodcq1500006283/b8e56566387702305400514718/c0FfsiSZHj0A.mp4',
            // src: '//1500006283.vod2.myqcloud.com/6c9ac49bvodcq1500006283/b8e56566387702305400514718/c0FfsiSZHj0A.mp4',
            img: swiper2img,
            desc: 'products.vidar.area4Tab2Desc'
          },
          {
            videoSrc:
              '//1500006283.vod2.myqcloud.com/6c9ac49bvodcq1500006283/e62a7aaf387702305404266944/MAQptZ3n2QwA.mp4',
            // src: '//1500006283.vod2.myqcloud.com/6c9ac49bvodcq1500006283/e62a7aaf387702305404266944/MAQptZ3n2QwA.mp4',
            img: swiper3img,
            desc: 'products.vidar.area4Tab3Desc'
          }
        ],
        imgDescData: [
          {
            videoSrc:
              '//1500006283.vod2.myqcloud.com/6c9ac49bvodcq1500006283/b275976f387702305400292769/3rnsZJiIQa8A.mp4',
            imgSrc: area6Video1img,
            title: 'products.vidar.area6Title1',
            desc: 'products.vidar.area6Desc1'
          },
          {
            videoSrc:
              '//1500006283.vod2.myqcloud.com/6c9ac49bvodcq1500006283/b27597d1387702305400292798/TXVe2j0ppQIA.mp4',
            imgSrc: area6Video2img,
            title: 'products.vidar.area6Title2',
            desc: 'products.vidar.area6Desc2'
          },
          {
            videoSrc:
              '//1500006283.vod2.myqcloud.com/6c9ac49bvodcq1500006283/b9530048387702305400576325/VxmIiNItq70A.mp4',
            imgSrc: area6Video3img,
            title: 'products.vidar.area6Title3',
            desc: 'products.vidar.area6Desc3'
          }
        ],
        activeIndex: 0,
        leftRightswiperOption: {
          loop: true,
          slidesPerView: 2.1, // 此值可以控制箭头左右距离
          spaceBetween: 16,
          centeredSlides: true,
          effect: 'slide',
          autoplay: 3700,
          pagination: {
            el: '.swiper-pagination-wrapper',
            // type: 'bullets',
            clickable: true
          },
          //  加上 navigation 不然会出现左右点击事件失效
          navigation: {
            nextEl: ' .swiper-button-next',
            prevEl: ' .swiper-button-prev'
          },
          on: {
            slideChange() {
              console.log(this.realIndex, 'this.realIndex')
              vm.activeIndex = this.realIndex
              // const activeIdx = this.realIndex
              // const swiperText = document.getElementsByClassName('img-bottom-desc')
              // Array.from(swiperText).forEach((item) => (item.style.opacity = 0))
              // swiperText[activeIdx].style.opacity = 1
              // console.log('[ swiperText ] >', swiperText[activeIdx].style.opacity)

              // swiperText.css({"opacity":"0"});
              // swiperText.eq(index).css({"opacity":"1"})
            }
          }
        },
        leftRightSwiperTitle: 'Application Scenarios',
        leftRightswiperData: [
          {
            imgSrc: leftRightSwiper1img,
            desc: 'Public Lawn'
          },
          {
            imgSrc: leftRightSwiper2img,
            desc: 'Sports Turf'
          },
          {
            imgSrc: leftRightSwiper3img,
            desc: 'Yard'
          },
          {
            imgSrc: leftRightSwiper4img,
            desc: 'Commercial Lawn'
          }
        ],
        mainTitle: 'products.vidar.area6H2'
      }
    },
    head() {
      return {
        title: 'FJD Vidar',
        meta: [
          {
            hid: 'keywords',
            name: 'keywords',
            content: 'Lawnmower, auto mower, Zero-Turn,100% Electric Control, FJDynamics, FJD '
          },
          // hid is used as unique identifier. Do not use `vmid` for it as it will not work
          {
            hid: 'description',
            name: 'description',
            content:
              'Redefine your mowing experience with GNSS positioning and robotics technology. To explore how FJDynamics makes a perfect cut'
          }
        ]
      }
    },
    created() {},
    mounted() {
      // eslint-disable-next-line nuxt/no-env-in-hooks
      if (process.browser) {
        const that = this
        gsap.registerPlugin(ScrollTrigger)
        this.area5Animation()
        ScrollTrigger.create({
          trigger: '.area-5',
          start: 'top top',
          // markers: true,
          onEnter() {
            that.loadImages(that.framesequence)
          }
        })
      }
    },
    methods: {
      area5Animation() {
        const sections = gsap.utils.toArray('.area-5-content section')
        gsap.to(sections, {
          xPercent: -95 * (sections.length - 1),
          ease: 'none',
          scrollTrigger: {
            trigger: '.area-5-content',
            scrub: 1,
            // duration:5,
            // markers: true,
            start: 'center+=500 center'
          }
        })
      },
      setImages() {
        const images = []
        let n
        let imgPath
        for (let i = 0; i <= 90; i++) {
          n = i < 10 ? '0' + i : i
          // 路径在下方拼接，否则找不到图片 出现 404 错误
          imgPath = `CG1_${n}.png`
          // imgPath = '@/assets/images/fjd-vidar/framesequence/CG1_' + n + '.png'
          images.push(imgPath)
        }
        return images
      },
      loadImages(fn) {
        let loaded = 0
        const loadedImgsArr = []
        const imgsArr = this.setImages()
        let imgObj = null
        imgsArr.forEach(function (value, index) {
          imgObj = new Image()
          // console.log({ imgObj })

          imgObj.onload = function () {
            loaded++
            if (loaded === imgsArr.length) {
              fn && fn(loadedImgsArr)
            }
          }
          // console.log('[ require(imgsArr[index]) ] >', imgsArr[index], 'AAA')
          // imgObj.src = require(imgsArr[index]) or imgObj.src = require(`${imgsArr[index]}`)  这俩种情况都加载失败
          // https://www.zhihu.com/question/421711093  require不能直接用变量接收地址
          const imgSrc = require(`./../../../assets/images/fjd-vidar/framesequence/${imgsArr[index]}`)
          imgObj.src = imgSrc
          loadedImgsArr.push(imgObj)
        })
      },
      framesequence(loadedImgsArr) {
        // const sequenceImg = $('#area-7-img')
        const sequenceImg = document.getElementById('area-7-img')
        let progress = ''
        gsap
          .timeline({
            scrollTrigger: {
              trigger: '.area-7',
              start: 'top top',
              end: 'bottom bottom',
              // markers: true,
              scrub: 1,
              onUpdate(self) {
                if (self.progress >= 0.9) return
                progress = self.progress.toFixed(2).slice(2)
                if (progress < 10) {
                  progress = progress.slice(1)
                }
                // console.log({ progress }, loadedImgsArr, sequenceImg.src)
                sequenceImg.src = loadedImgsArr[progress].src
                // sequenceImg.attr('src', loadedImgsArr[progress].src)
              }
            }
          })
          .to('#safety-title', {
            y: '-60%',
            opacity: 0,
            duration: 0.01
          })
          .to('#indicator-light', {
            opacity: 1,
            duration: 0.02,
            y: '-50%'
          })
          .to('#indicator-light', {
            opacity: 0,
            y: '-60%',
            duration: 0.01
          })
          .to('#hand-brake', {
            opacity: 1,
            duration: 0.05,
            y: '-50%'
          })
          .to('#hand-brake', {
            duration: 0.01,
            opacity: 0,
            y: '-60%'
          })
          .to('#stop-button', {
            opacity: 1,
            duration: 0.05,
            y: '-50%'
          })
      }
    }
  }
</script>

<style scoped lang="scss">
  .area-3 {
    margin-top: 1.6rem;
    // margin-bottom: 1.6rem;
    h2 {
      font-size: 0.48rem;
      color: #333;
    }
    .desc {
      margin: 0.24rem 0 0.32rem;
    }
  }
  .area-3 .img-box {
    width: 9.72rem;
    height: 5.46rem;
  }
  .area-3 .text strong {
    font-size: 0.64rem;
  }
  .area-3 .text strong::before {
    display: inline-block;
    vertical-align: top;
    margin: 0.12rem 0.18rem 0 0;
    content: '';
    width: 0.17rem;
    height: 0.3rem;
    background: url("data:image/svg+xml,%3Csvg width='17' height='30' viewBox='0 0 17 30' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink'%3E%3Cdefs%3E%3Cpath d='M11.333 0v18.45H17L8.5 30 0 18.45h6.044V0h5.29z' id='a'/%3E%3C/defs%3E%3Cuse fill='%23333' transform='matrix(-1 0 0 1 17 0)' xlink:href='%23a' fill-rule='evenodd'/%3E%3C/svg%3E")
      no-repeat center / cover;
  }
  .area-3 .text div:nth-of-type(2) strong::before {
    transform: rotate(180deg);
  }
  .area-3 .text .line {
    width: 2.02rem;
    margin: 0.12rem 0;
    border: none;
    border-top: 1px solid rgba(51, 51, 51, 1);
  }
  .area-3 .text > div:nth-of-type(1) {
    margin-bottom: 1.42rem;
  }
  // area: 5px;  /* area-5 */
  .area-5 {
    margin-bottom: 1.6rem;
    height: 250vh;
  }
  .area-5-content {
    position: sticky;
    top: 0.56rem;
    height: calc(100vh - 0.56rem);
  }
  .area-5 section {
    flex: 0 0 auto;
    background-color: rgba(17, 17, 17, 1);
  }
  .area-5 .panner-1 {
    width: 100%;
  }
  .area-5 .panner-1 h2 {
    margin-bottom: 0.41rem;
  }
  .area-5 .panner-1 .desc {
    font-size: 0.24rem;
    color: rgba(238, 238, 238, 1);
  }
  .area-5 .panner-1 > div {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }
  .area-5 .panner-2 > div {
    padding: 0 2.82rem;
  }
  .area-5 .panner-2 .img-box {
    width: 9.72rem;
    height: 5.46rem;
  }
  .area-5 .panner-2 h2 {
    margin-bottom: 0.16rem;
  }
  .area-5 .panner-2 .mod-1 {
    margin-right: 0.8rem;
    display: flex;
    flex-direction: column-reverse;
  }
  .area-5 .panner-2 .mod-1 .img-box {
    margin-bottom: 0.32rem;
  }
  .area-5 .panner-2 .mod-2 .img-box {
    margin-top: 0.32rem;
  }
  // area7
  /* area-7 */
  .area-7 {
    height: 250vh;
    margin-bottom: 1.6rem;
    background-color: #000;
  }
  .area-7-content {
    position: sticky;
    padding-bottom: 1.6rem;
    top: calc((100vh - 8rem) / 2);
    // height: 8rem;
  }
  .area-7-content .img-box {
    width: 6rem;
    height: 8rem;
    margin-right: 1.29rem;
  }
  .area-7-content .desc-wrap {
    width: 4.5rem;
    height: 1.5rem;
  }
  .area-7-content .desc-wrap h2 {
    color: #fff;
    position: absolute;
    top: 50%;
    transform: translateY(-30%);
    font-size: 0.48rem;
  }
  .area-7-content .desc-text {
    opacity: 0;
    position: absolute;
    top: 50%;
    transform: translateY(-30%);
    border-left: 2px solid #fff;
    padding-left: 0.3rem;
    font-size: 0.24rem;
    color: #fff;
  }
  .area-7-content .desc-text h3 {
    margin-bottom: 0.16rem;
    font-size: 0.36rem;
    font-weight: 500;
  }
  .area-7-content .desc-text h3:nth-of-type(2) {
    margin-top: 0.32rem;
  }
  /* area-9 */
  .area-9 {
    padding-top: 1.6rem;
    padding-bottom: 1.6rem;
  }
  .area-9-in {
    margin: 0 5.12rem;
  }
  .area-9 h2 {
    font-size: 0.48rem;
    font-weight: 700;
    margin-bottom: 0.32rem;
  }
  .area-9 .img-box {
    width: 7.44rem;
    height: 4.2rem;
    margin: 0 auto;
  }
  .area-9 h3 {
    font-size: 0.28rem;
    margin: 0.32rem 0 0.24rem;
    font-weight: 500;
  }

  // ui
  .area-2 {
    :deep(.desc) {
      width: 12rem;
      text-align: left;
    }
    :deep(.video-box) {
      // width: 12rem;
      height: auto;
    }
  }
  .area-5 {
    h2 {
      font-size: 0.48rem;
    }
  }
</style>
